export default __webpack_public_path__ + "static/media/scale.ba33a884.png";